import '@warp-drive/ember/install';
import { setBuildURLConfig } from '@ember-data/request-utils';
import Application from '@ember/application';
import embroiderCompatModules from '@embroider/virtual/compat-modules';
import config from './config/environment';
import loadInitializers from 'ember-load-initializers';
import Resolver from 'ember-resolver';
import setupInspector from '@embroider/legacy-inspector-support/ember-source-4.12';

import { getCompatModules } from 'tio-common/compat-modules';

const additionalCompatModules = getCompatModules(config.modulePrefix);

const compatModules = {
  ...additionalCompatModules,
  ...embroiderCompatModules,
};

setBuildURLConfig({
  host: config.apiHost,
  namespace: '',
});

export default class App extends Application {
  modulePrefix = config.modulePrefix;
  podModulePrefix = config.podModulePrefix;
  Resolver = Resolver.withModules(compatModules);
  inspector = setupInspector(this);
}

loadInitializers(App, config.modulePrefix, compatModules);
